module.exports = __webpack_public_path__ + "img/9788932906096.52062040.jpg";